/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ lens: NonNullable<unknown> }} Palette_LensInputs */

const en_palette_lens = /** @type {(inputs: Palette_LensInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Show ${i?.lens}`)
};

/**
* | output |
* | --- |
* | "Show {lens}" |
*
* @param {Palette_LensInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const palette_lens = /** @type {((inputs: Palette_LensInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Palette_LensInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_palette_lens(inputs)
});